export default "__VITE_ASSET__DUkrb38___"